import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import HeaderDashboard from './HeaderDashboard';
import Footer from './Footer';
import FooterDashboard from './FooterDashboard';
import FooterHome from './FooterHome';

const Layout = ({ children }) => {
  const footerText = 'Copyright © 2025 WolfTech LLC, All Rights Reserved.';
  const location = useLocation();
  let headerComponent = null;
  let footerComponent = null;

  const isGroupDetailPage = /^\/groups\/[^/]+$/.test(location.pathname);

  if (location.pathname === '/dashboard') {
    footerComponent = <FooterDashboard footerText={footerText} />;
  } else if (location.pathname === '/auth' || 
    location.pathname === '/create-organization' ||
    location.pathname === '/staged-groups' || 
    location.pathname === '/confirmation' ||
    location.pathname === '/finish-setup' ||
    location.pathname === '/setup-admin' ||
    isGroupDetailPage ||
    location.pathname === '/download-joltchat') {  
    headerComponent = <HeaderDashboard footerText={footerText} />;
    footerComponent = <Footer footerText={footerText} />;
  } else if (location.pathname === '/features') {
    headerComponent = <Header footerText={footerText} />;
    footerComponent = <Footer footerText={footerText} />;
  }
  else {
    headerComponent = <Header />;
    footerComponent = <FooterHome footerText={footerText} />;
  }

  return (
    <>
      {headerComponent}
      {children}
      {footerComponent}
    </>
  );
};

export default Layout;